module.exports = __webpack_public_path__ + "static/media/door-gray.ccfc1558.svg";